import { BrowserView, MobileView } from "react-device-detect";
import { ConfirmationVerifyDesktop } from "./confirmationVerifyDesktop";
import { ConfirmationVerifyMobile } from "./confirmationVerifyMobile";
export const ConfirmationVerify = () => {
  return (
    <>
      <BrowserView>
        <ConfirmationVerifyDesktop></ConfirmationVerifyDesktop>
      </BrowserView>
      <MobileView>
        <ConfirmationVerifyMobile></ConfirmationVerifyMobile>
      </MobileView>
    </>
  );
};
